module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-5-866af9de52a24c3c11d45e1b0fc63026.jpg";